import { TypeAsserter, TypeChecker } from '@attain-apps/type-guards'

import type * as core from '../../../core'

export enum OutgoingFundsAmount {
  Over650k = 'outgoing-funds-over-650k',
  From150kTo649k = 'outgoing-funds-150k-to-649k',
  From25kTo149k = 'outgoing-funds-25k-to-149k',
  From1To24k = 'outgoing-funds-1k-to-24k',
}

const OUTGOING_FUND_AMOUNTS: ReadonlySet<OutgoingFundsAmount> = new Set(
  Object.values(OutgoingFundsAmount) as OutgoingFundsAmount[],
)
export namespace OutgoingFundsAmount {
  export const ALL: readonly OutgoingFundsAmount[] = Array.from(
    OUTGOING_FUND_AMOUNTS,
  )
  export const isOutgoingFundsAmount = TypeChecker.Factory.oneOf(
    OUTGOING_FUND_AMOUNTS,
  )
  export const assertIsOutgoingFundsAmount: TypeAsserter<OutgoingFundsAmount> =
    TypeAsserter.Factory.from(isOutgoingFundsAmount)

  /**
   * Returns the {@link core.common.value.types.Enum.Entry} for the given
   * {@link OutgoingFundsAmount}
   */
  export function getEntry(
    outgoingFundsAmount: OutgoingFundsAmount,
  ): core.common.value.types.Enum.Entry {
    return { ...ENTRY_LOOKUP[outgoingFundsAmount], id: outgoingFundsAmount }
  }
  /** Used by {@link getEntry} */
  const ENTRY_LOOKUP: Record<
    OutgoingFundsAmount,
    Omit<core.common.value.types.Enum.Entry, 'id'>
  > = {
    [OutgoingFundsAmount.Over650k]: { name: 'Outgoing Funds > $650,000' },
    [OutgoingFundsAmount.From150kTo649k]: {
      name: 'Outgoing Funds $150,000 – $649,999',
    },
    [OutgoingFundsAmount.From25kTo149k]: {
      name: 'Outgoing Funds $25,000 - $149,999',
    },
    [OutgoingFundsAmount.From1To24k]: { name: 'Outgoing Funds $1 - $24,999' },
  }
}
